/**
 * Toast notification component.
 * Displays notifications from the store with Vuexy-styled alerts.
 * Based on Vuexy toast/notification patterns.
 */

// MUI Imports
import { Snackbar, Alert } from '@mui/material';
import type { AlertColor } from '@mui/material';

// Store Imports
import { useNotificationStore } from '../../store/notificationStore';

/**
 * Toast notification component that displays notifications from the store.
 * Styled to match Vuexy design guidelines.
 */
export const Toast = () => {
  const { notifications, removeNotification } = useNotificationStore();

  if (notifications.length === 0) {
    return null;
  }

  const notification = notifications[0];

  return (
    <Snackbar
      open={true}
      autoHideDuration={notification.duration || 4000}
      onClose={() => removeNotification(notification.id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        // Vuexy-style positioning and spacing
        '& .MuiSnackbar-root': {
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
        },
      }}
    >
      <Alert
        onClose={() => removeNotification(notification.id)}
        severity={notification.type as AlertColor}
        variant="filled"
        sx={{
          // Vuexy-style alert styling
          borderRadius: 1,
          boxShadow: 'var(--mui-customShadows-md)',
          '& .MuiAlert-icon': {
            fontSize: '1.25rem',
          },
          '& .MuiAlert-message': {
            fontSize: '0.9375rem', // 15px - Vuexy base font size
            fontWeight: 400,
          },
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
